import { Typography, makeStyles } from '@material-ui/core';
import { PhxIamPolicyMultiSelect } from '../../PhxIamPolicyMultiSelect';

const useStyles = makeStyles(theme => ({
  iamPoliciesSection: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
  },
}));

interface LambdaIamPoliciesEditorProps {
  iamPolicyNames: string[];
  onUpdate: (policies: string[]) => void;
  title?: string;
}

export const LambdaIamPoliciesEditor = ({
  iamPolicyNames,
  onUpdate,
  title = 'IAM Policies (optional)',
}: LambdaIamPoliciesEditorProps) => {
  const classes = useStyles();

  return (
    <div className={classes.iamPoliciesSection}>
      <div style={{ marginBottom: 16 }}>
        <Typography variant="subtitle2">{title}</Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ fontSize: '0.75rem', marginTop: 4 }}
        >
          Additional IAM policies for this lambda
        </Typography>
      </div>

      <PhxIamPolicyMultiSelect
        value={iamPolicyNames}
        onChange={onUpdate}
        label="IAM Policy Names"
        helperText="Select from existing policies"
        variant="outlined"
        size="small"
      />
    </div>
  );
};
